/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { Plans } from 'cio/utils/billing/plans';
import BillingService from 'cio/services/billing';
import { PlanType } from 'cio/models/plan';
import ObjectTypesService from 'cio/services/object-types';

export default class ObjectsIntroSection extends Component {
  @service billing!: BillingService;
  @service objectTypes!: ObjectTypesService;

  @tracked container: HTMLDivElement | null = null;

  get planDetails() {
    let { subscription, billingInfo, planNameShortened } = this.billing;
    let plan = Object.values(Plans).find((p) => {
      let matched = p.planType === subscription?.plan.planType;
      if (matched && p.planType === PlanType.Startup) {
        matched = p.name === subscription?.plan.name;
      }
      return matched;
    });
    // Plan details for trial plans
    if (billingInfo?.trial === true) {
      plan = Plans.Essentials;
    }
    if (plan == null) {
      return;
    }
    // let { objects, meteredObjectRate } = subscription.plan; // Use this when releasing all Object Pricing changes
    return {
      name: planNameShortened,
      objectTypeLimit: plan.planLimits.objectTypes?.value ?? 2,
      baseObjectCount: plan.baseObjectCount,
      baseMeteredObjectRate: plan.baseMeteredObjectRate ?? 0.009,
    };
  }

  @action
  didInsertContainer(container: HTMLDivElement) {
    this.container = container;
  }
}
